import React from "react";
import { useNavigate } from "react-router-dom";
import assets from "../../utils/ImagesPath";
import { Row, Col, Card, Image, Typography, Button } from "antd";
const { Title } = Typography;

const ErrorWidget = () => {
  let navigate = useNavigate();
  return (
    <Row gutter={[0, 0]}>
      <Col md={24}>
        <Card align="middle">
          <Image preview={false} alt="Error Image" src={assets.error} />
          <Title level={1} style={{ textAlign: "center" }}>
            Oops, looks like something went wrong!
          </Title>
          <Title level={5} style={{ textAlign: "center" }}>
            The requested URL was not found on this server.....
          </Title>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "3em",
            }}
          ></div>
          <Button type="primary" shape="round" onClick={() => navigate(-1)}>
            {" "}
            Go Back{" "}
          </Button>
        </Card>
      </Col>
    </Row>
  );
};

export default ErrorWidget;
